import {
    IconHeart,
    IconHeartFilled,
    IconMessageCircle,
    IconSend,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Text } from "@fragments";

import "./styles.scss";

/**
 * PostActions — the heart / comment / share row shared by the feed card and
 * the post modal. Reads counts and the viewer's heart straight from the post;
 * the parent owns what each action does. Once the viewer has hearted the
 * post, the whole heart chip (fill, icon and count) takes the error tint.
 */
export default function PostActions({
    post,
    onReact,
    onComment,
    onShare,
    busy = false,
    className = "",
}) {
    const { t } = useTranslation("community");

    const heart = post?.reactions?.heart || {};
    // Tolerate a "1"/"true" from older rows as well as a real boolean.
    const reacted = heart.reacted === true || heart.reacted === 1 || heart.reacted === "1" || heart.reacted === "true";
    const hearts = Number(heart.amount || 0);
    const comments = Number(post?.insights?.comments || 0);

    return (
        <div
            className={`post-actions ${className}`.trim()}
            onClick={(e) => e.stopPropagation()}
        >
            <button
                type="button"
                className={`post-actions__item${reacted ? " post-actions__item--reacted" : ""}`}
                onClick={onReact}
                disabled={busy}
                aria-pressed={reacted}
                aria-label={t("feed.react")}
                title={t("feed.react")}
            >
                {reacted ? <IconHeartFilled /> : <IconHeart />}
                {hearts > 0 && (
                    <Text.span contrast={7} className="post-actions__count">
                        {hearts}
                    </Text.span>
                )}
            </button>

            <button
                type="button"
                className="post-actions__item"
                onClick={onComment}
                aria-label={t("feed.comment")}
                title={t("feed.comment")}
            >
                <IconMessageCircle />
                {comments > 0 && (
                    <Text.span contrast={7} className="post-actions__count">
                        {comments}
                    </Text.span>
                )}
            </button>

            <button
                type="button"
                className="post-actions__item"
                onClick={onShare}
                aria-label={t("common:actions.share")}
                title={t("common:actions.share")}
            >
                <IconSend />
            </button>
        </div>
    );
}
